(() => {
  const R = (window.Moveo && window.Moveo.routes) || {};
  const root = R.root && R.root !== '/' ? R.root : '';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* Autoplay muted background videos (some browsers need a nudge). */
  const visible = (v) => v.getClientRects().length > 0;
  const playAll = () => $$('video[autoplay]').forEach((v) => {
    v.muted = true;
    if (!visible(v)) { v.preload = 'none'; v.pause(); return; }
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  });
  playAll();
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting && visible(v)) { v.preload = 'auto'; const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      else v.pause();
    }), { rootMargin: '200px' });
    $$('video[autoplay]').forEach((v) => io.observe(v));
  }

  /* Product page deal timer: per-visitor countdown, restarts when it ends.
     Starts one second under the set minutes (23 → 22:59). */
  const deal = $('[data-deal-timer]');
  if (deal) {
    const mm = $('[data-deal-mm]', deal);
    const ss = $('[data-deal-ss]', deal);
    const span = ((parseInt(deal.dataset.minutes, 10) || 23) * 60 - 1) * 1000;
    const key = 'mv-deal-end';
    let end = 0;
    try { end = parseInt(localStorage.getItem(key), 10) || 0; } catch (_) {}
    const reset = () => { end = Date.now() + span; try { localStorage.setItem(key, String(end)); } catch (_) {} };
    if (!end || end <= Date.now() || end - Date.now() > span) reset();
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let left = end - Date.now();
      if (left <= 0) { reset(); left = span; }
      const sec = Math.ceil(left / 1000);
      mm.textContent = pad(Math.floor(sec / 60));
      ss.textContent = pad(sec % 60);
      deal.classList.toggle('is-urgent', sec <= 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* Mobile menu */
  const mnav = $('#mnav');
  const menuBtn = $('[data-menu-open]');
  if (mnav && menuBtn) {
    const closeMenu = () => { mnav.hidden = true; menuBtn.setAttribute('aria-expanded', 'false'); };
    menuBtn.addEventListener('click', () => {
      if (!mnav.hidden) { closeMenu(); return; }
      const pill = menuBtn.closest('.navpill') || menuBtn;
      mnav.style.setProperty('--mnav-top', `${Math.max(12, pill.getBoundingClientRect().bottom + 10)}px`);
      mnav.hidden = false; menuBtn.setAttribute('aria-expanded', 'true');
    });
    $$('[data-menu-close]', mnav).forEach((el) => el.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !mnav.hidden) closeMenu(); });
  }

  /* Toast */
  const toast = $('[data-toast]');
  let toastTimer;
  const showToast = (text) => {
    if (!toast) return;
    if (text) $('[data-toast-text]', toast).textContent = text;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-on'), 2200);
  };

  /* Cart drawer */
  const drawer = $('[data-drawer]');
  let lastFocus = null;
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; });
  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    const panel = $('[data-drawer-panel]', drawer);
    if (panel) panel.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus) lastFocus.focus();
  };
  const refreshDrawer = async () => {
    const res = await fetch(`${root}/?section_id=cart-drawer`, { credentials: 'same-origin' });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-drawer-panel]');
    const current = drawer && $('[data-drawer-panel]', drawer);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    const cart = await fetch(`${root}/cart.js`, { credentials: 'same-origin' }).then((r) => r.json());
    setCount(cart.item_count);
  };
  if (drawer) {
    $$('[data-cart-open]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
    drawer.addEventListener('click', async (e) => {
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
      const btn = e.target.closest('[data-line-change]');
      if (!btn) return;
      btn.disabled = true;
      await fetch(`${R.cartChange || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: btn.dataset.lineChange, quantity: Math.max(0, parseInt(btn.dataset.lineQty, 10) || 0) })
      });
      await refreshDrawer();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  }

  /* Color studio */
  const studio = $('[data-studio]');
  const syncStudio = (name) => {
    if (!studio) return;
    const btn = $$('[data-studio-color]', studio).find((b) => b.dataset.studioColor === name);
    if (!btn) return;
    $$('[data-studio-color]', studio).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    studio.style.background = btn.dataset.tint;
    $('[data-studio-ring]', studio).setAttribute('stroke', btn.dataset.hex);
    $('[data-studio-ball]', studio).setAttribute('fill', btn.dataset.hex);
    const word = $('[data-studio-word]', studio);
    word.textContent = name; word.style.color = btn.dataset.hex;
    $('[data-studio-vibe]', studio).textContent = btn.dataset.vibe;
    $('[data-studio-name]', studio).textContent = name;
    const ring = $('[data-sticky-ring]');
    if (ring) ring.style.borderColor = btn.dataset.hex;
  };
  if (studio) {
    $$('[data-studio-color]', studio).forEach((btn) => btn.addEventListener('click', () => {
      const name = btn.dataset.studioColor;
      syncStudio(name);
      document.dispatchEvent(new CustomEvent('moveo:color', { detail: { name, from: 'studio' } }));
    }));
  }

  /* Product form */
  const section = $('[data-product-section]');
  if (section) {
    const data = JSON.parse($('[data-product-json]', section).textContent);
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-btn]', form);
    const addLabel = $('[data-add-label]', form);
    const qty = $('input[name="quantity"]', form);
    const mainImg = $('.gal__main', section);

    const selected = () => $$('input[data-option]:checked', form)
      .sort((a, b) => a.dataset.option - b.dataset.option)
      .map((i) => i.value);

    const update = () => {
      const opts = selected();
      const v = data.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('[data-option-label]', form).forEach((el) => { el.textContent = opts[+el.dataset.optionLabel] || ''; });
      const sn = $('[data-sticky-name]'); if (sn) sn.textContent = opts[0] || '';
      if (!v) { addBtn.disabled = true; addLabel.textContent = data.strings.unavailable; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? data.strings.add : data.strings.soldOut;
      const now = $('[data-price-now]', section); if (now) now.textContent = v.price;
      const was = $('[data-price-was]', section); if (was && v.compare) was.textContent = v.compare;
      const save = $('[data-price-save]', section); if (save && v.save) save.textContent = `${data.strings.save || "חוסכת"} ${v.save}`;
      if (v.image && mainImg) {
        mainImg.src = v.image; mainImg.removeAttribute('srcset');
        const track = $('[data-gal-track]', section);
        if (track && track.scrollLeft !== 0) track.scrollTo({ left: 0, behavior: 'smooth' });
      }
      const dot = $('input[data-option="0"]:checked + span', form);
      const ring = $('[data-sticky-ring]');
      if (dot && ring && !studio) ring.style.borderColor = dot.style.background;
      const url = new URL(window.location.href);
      if (url.pathname.includes('/products/')) { url.searchParams.set('variant', v.id); history.replaceState(null, '', url); }
    };

    form.addEventListener('change', (e) => {
      if (!e.target.matches('input[data-option]')) return;
      update();
      if (e.target.dataset.option === '0') {
        syncStudio(e.target.value);
      }
    });
    document.addEventListener('moveo:color', (e) => {
      if (e.detail.from !== 'studio') return;
      const input = $$('input[data-option="0"]', form).find((i) => i.value === e.detail.name);
      if (input) { input.checked = true; update(); }
    });

    $$('[data-qty]', form).forEach((b) => b.addEventListener('click', () => {
      qty.value = Math.min(20, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10)));
    }));

    $$('[data-gal-thumb]', section).forEach((t) => t.addEventListener('click', () => {
      if (!mainImg) return;
      mainImg.src = t.dataset.galThumb; mainImg.removeAttribute('srcset');
      $$('[data-gal-thumb]', section).forEach((x) => x.setAttribute('aria-current', String(x === t)));
    }));

    form.addEventListener('submit', async (e) => {
      if (!drawer) return;
      e.preventDefault();
      addBtn.disabled = true;
      try {
        const res = await fetch(`${R.cartAdd || '/cart/add'}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          showToast(err.description || 'משהו השתבש, נסי שוב');
        } else {
          await refreshDrawer();
          showToast();
          openDrawer();
        }
      } catch (_) {
        form.submit();
      } finally {
        update();
      }
    });

    /* Product page carousel: arrows, dots, counter */
    const track = $('[data-gal-track]', section);
    if (track) {
      const slides = Array.from(track.children);
      const dots = $$('[data-gal-dot]', section);
      const prev = $('[data-gal-prev]', section);
      const next = $('[data-gal-next]', section);
      const now = $('[data-gal-now]', section);
      const sign = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      const current = () => Math.min(slides.length - 1, Math.max(0, Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1))));
      const goTo = (i) => {
        const n = (i + slides.length) % slides.length;
        track.scrollTo({ left: sign * n * track.clientWidth, behavior: 'smooth' });
      };
      const render = () => {
        const i = current();
        dots.forEach((d, n) => { d.classList.toggle('is-on', n === i); d.setAttribute('aria-current', String(n === i)); });
        if (now) now.textContent = i + 1;
      };
      track.addEventListener('scroll', render, { passive: true });
      if (prev) prev.addEventListener('click', () => goTo(current() - 1));
      if (next) next.addEventListener('click', () => goTo(current() + 1));
      dots.forEach((d) => d.addEventListener('click', () => goTo(parseInt(d.dataset.galDot, 10))));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() + (sign === -1 ? 1 : -1)); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + (sign === -1 ? -1 : 1)); }
      });
      render();
    }

    /* Mobile sticky bar: show when the buy box is off screen */
    const sticky = $('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      let pastHero = false; let buyVisible = false;
      const render = () => sticky.classList.toggle('is-on', pastHero && !buyVisible);
      new IntersectionObserver(([e]) => { buyVisible = e.isIntersecting; render(); }).observe(section);
      const hero = $('.hero');
      if (hero) new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; render(); }).observe(hero);
      else pastHero = true;
    }

    update();
  }
})();
